import { render, staticRenderFns } from "./TransactionAmount.vue?vue&type=template&id=6e9ecad1&scoped=true"
import script from "./TransactionAmount.vue?vue&type=script&lang=js"
export * from "./TransactionAmount.vue?vue&type=script&lang=js"
import style0 from "./TransactionAmount.vue?vue&type=style&index=0&id=6e9ecad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9ecad1",
  null
  
)

export default component.exports